import React, { useEffect, useState } from "react";
// material-ui
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import TableChart from "@material-ui/icons/TableChart";
import LocationOnIcon from '@material-ui/icons/LocationOn';

import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  LoadScript,
  OverlayView
} from "@react-google-maps/api";
// core components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import { getAllLockers } from "../../services/lockers/lockers";
import { createBrowserHistory } from "history";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

var styles = {
  ...dashboardStyle,
  cardTitle: {
    marginTop: "0",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  }
};

const useStyles = makeStyles(styles);

const containerStyle = {
  width: "100%",
  height: "100vh",
  flex: 1,
};

let center = {
  lat: -14.235004,
  lng: -51.92528,
};

let zoom = 5;

export default function Maps() {
  const classes = useStyles();
  const [lockers, setLocker] = useState([]);

  if (!localStorage.getItem("user")) {
    createBrowserHistory({ forceRefresh: true }).push("/");
  } else {
    createBrowserHistory({ forceRefresh: false }).push(`/`);
  }

  let geo = JSON.parse(localStorage.getItem("geo"));

  if (geo) {
    center = {
      lat: Number(geo.lat),
      lng: Number(geo.lng)
    }

    zoom = 15;
  } else {
    center = {
      lat: -14.235004,
      lng: -51.92528,
    };

    zoom = 5;

  }

  useEffect(() => {
    getAllLockers((data) => {
      let lockersData = data.filter((d) => d.geolocation);
      setLocker(lockersData);
      console.log(JSON.stringify(lockersData))
      localStorage.removeItem("geo");
    });
  }, []);

  return (
    <LoadScript googleMapsApiKey="AIzaSyAn3z1j80FOBzdsquORvdb1pEqlAtir1bY">
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={zoom}
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: `100vh` }} />}
      >
        {/* Child components, such as markers, info windows, etc. */
          lockers.map((locker) => (
            <OverlayView
              position={
                {
                  lat: locker.geolocation.latitude,
                  lng: locker.geolocation.longitude
                }
              }
              title={locker.name}
              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
              key={locker.id}
            >
              <div className="extra-cards">
                <Card className="locker-extra-cards">
                  {locker.status === 'active' ?
                    <CardHeader className="locker-align-text-left" color="primary" icon>
                      <CardIcon className="locker-maps" color="primary">
                        <LocationOnIcon />
                      </CardIcon>
                    </CardHeader> : <CardHeader className="locker-align-text-left" color="danger" icon>
                      <CardIcon className="locker-maps" color="danger">
                        <LocationOnIcon />
                      </CardIcon>
                    </CardHeader>}
                  <CardBody>
                    {locker.name}
                  </CardBody>
                </Card>
              </div>
            </OverlayView>
          ))}
        <></>
      </GoogleMap>
    </LoadScript>
  );
}
